"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_1 = __importDefault(require("styled-components"));

var Container = styled_components_1.default("span")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  font-family: \"Nunito Sans\", sans-serif;\n  padding: 5px 10px;\n  color: white;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding-top: 6px;\n  line-height: 1;\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  font-family: \"Nunito Sans\", sans-serif;\n  padding: 5px 10px;\n  color: white;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding-top: 6px;\n  line-height: 1;\n"])), function (props) {
  if (props.bgColor === "primary") {
    return "#2D4EF5";
  } else if (props.bgColor === "success") {
    return "#4CE2A7";
  } else if (props.bgColor === "error") {
    return "#E24C4C";
  } else if (props.bgColor === "alert") {
    return "#F1A153";
  } else if (props.bgColor === "dark") {
    return "#022047";
  }
}, function (props) {
  if (props.edges === "sharp") {
    return "0px";
  } else if (props.edges === "rounded") {
    return "25px";
  } else if (props.edges === "round-sharp") {
    return "3px";
  }
});

exports.Tag = function (_a) {
  var text = _a.text,
      _b = _a.edges,
      edges = _b === void 0 ? "sharp" : _b,
      _c = _a.bgColor,
      bgColor = _c === void 0 ? "primary" : _c,
      className = _a.className;
  return react_1.default.createElement(Container, {
    bgColor: bgColor,
    edges: edges,
    className: className
  }, text);
};

exports.Tag.propTypes = {
  text: prop_types_1.default.string,
  edges: prop_types_1.default.oneOf(["sharp", "rounded", "round-sharp"]),
  bgColor: prop_types_1.default.oneOf(["primary", "success", "error", "alert", "dark"])
};
var templateObject_1;